export default __webpack_public_path__ + "static/media/logo-call-wednesday.38bb7b2b.png";